//
// CONFIGURATION
//
// key: {
//   editor: default | book | instagram | coupon | new,
//   source: photos | instagram | ancestry | calendar,
//   preview: default | book | book-complex | polotno | calendar,
//   numberOfPages: { xs: 1 },
//   fullColWidth: false,
//   withQualityCheck: false,
// }
//
// 'key' - String, represents sku
// 'editor' - String - default is "default"
// 'source' - Combined only with new editor. String, for source selection - default is "photos"
// 'preview' - Combined only with new editor. String, for print preview - default is "default"
// 'numberOfPages' - Object, default is { xs: 2 }
// 'fullColWidth' - Bool, maximum page width of Col, default is false
// 'withQualityCheck' - Bool, show quality of photos indicator, default is false
// 'requiredPhotos' - Bool, defines that all of photos are required, default is true
// 'requiredTexts' - Bool, defines that all of texts are required, default is false
// 'withMultiProductDesignSelect' - Bool, when true, editor tries to group alternatives by themes (FHP). default is false.
// 'devices' - Array, defines users device which is allowed to use this editor, default is ["mobile", "tablet", "desktop"]
// 'versions' - Object, defines overrides for each custom version.
// 'withPolotnoBackgrounds' - Polotno editor will offer backgrounds section. Default is undefined
// 'withPolotnoEmbellish' - Polotno editor will offer embellish section. Default is true.
// 'withPolotnoAncestry' - Polotno editor will offer ancestry section. Default is true.
// 'withPolotnoSettings' - Polotno editor will offer settings section. Default is undefined
// 'withoutFirstBlankPage' - Book editor will not show blank page in thumbs. Default is undefined.
// 'numberOfGenerations' - Number, temp var - It defines default number of generations, in the future user will choose this value.
// 'numberOfMonths' - Number. It defines default number of months in calendar. Default is 12.
//

const numberOfPagesForMultiPhotoProduct = { xs: 2, sm: 2, md: 3, lg: 4, xl: 4 };
const numberOfPagesForCalendars = { xs: 2, sm: 2, md: 3, lg: 3, xl: 3 };

const PRODUCT_EDITOR_CONFIG = {
  /**
   * DEFAULT EDITOR
   */
  'gold-square-small': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'gold-square-large': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'silver-square-small': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'silver-square-large': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'square-print': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'square-print-small': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'tiny-square-prints': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  retroprints: {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  recprints: {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  "recprints-small": {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'recprints-large': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  "recprints-small-gloss": {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'recprints-large-gloss': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },
  'grid-print-4': {
    numberOfPages: { xs: 2 },
  },
  'grid-print-9': {
    numberOfPages: { xs: 3 },
  },
  'grid-print-12': {
    numberOfPages: { xs: 4 },
  },
  'photo-strip': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
  },

  /**
   * CALENDARS
   */
  'wall-calendar': {
    numberOfPages: numberOfPagesForCalendars,
    fullColWidth: true,
  },
  'wall-calendar-large': {
    numberOfPages: numberOfPagesForCalendars,
    fullColWidth: true,
  },
  'desktop-calendar': {
    numberOfPages: numberOfPagesForCalendars,
    fullColWidth: true,
  },
  'desktop-calendar-flip': {
    numberOfPages: numberOfPagesForMultiPhotoProduct,
    fullColWidth: true,
  },

  /**
   * QUALITY CHECK
   */
  'engineer-print': { withQualityCheck: true },
  'engineer-print-calendar': { withQualityCheck: true },
  'news-print': { withQualityCheck: true },
  'square-engineer-print': { withQualityCheck: true },

  'artprint-11x14-satin': { withQualityCheck: true },
  'artprint-11x14-borderless': { withQualityCheck: true },
  'artprint-11x14': { withQualityCheck: true },
  'artprint-20x24-satin': { withQualityCheck: true },
  'artprint-20x24-borderless': { withQualityCheck: true },
  'artprint-20x24': { withQualityCheck: true },
  'artprint-8x10-satin': { withQualityCheck: true },
  'artprint-8x10-borderless': { withQualityCheck: true },
  'artprint-8x10': { withQualityCheck: true },
  'artprint-large-satin': { withQualityCheck: true },
  'artprint-large-borderless': { withQualityCheck: true },
  'artprint-large': { withQualityCheck: true },
  'artprint-small-satin': { withQualityCheck: true },
  'artprint-small-borderless': { withQualityCheck: true },
  'artprint-small': { withQualityCheck: true },

  /**
   * BOOK EDITOR
   * `eyebrow` labels the preview step (book preview v2). The SKU ids carry no
   * size, so it is spelled out here.
   */
  'photolane-hardcover-photo-book': {
    editor: 'book',
    eyebrow: ['Photo book', '8×8 in', 'Hardcover'],
  },
  'softcover-photo-book': {
    editor: 'book',
    eyebrow: ['Photo book', '6×6 in', 'Softcover'],
  },
  'photolane-softcover-photo-book': {
    editor: 'book',
    eyebrow: ['Photo book', '8×8 in', 'Softcover'],
  },
  'hardcover-photo-book': {
    editor: 'book',
  },

  /**
   * INSTAGRAM YEARBOOK EDITOR
   */
  'instagram-yearbook-small': {
    editor: 'instagram',
  },
  'instagram-yearbook-large': {
    editor: 'instagram',
  },

  'book-8x8-softcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
  },
  'book-8x8-hardcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
  },
  'book-8x8-layflat-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    withoutFirstBlankPage: true,
  },
  'book-11x8-layflat-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    withoutFirstBlankPage: true,
  },
  'book-11x8-hardcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-linen-gray': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-linen-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-linen-cream': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-leather-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-11x8-hardcover-leather-tan': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '11x8.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-custom': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-linen-gray': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-linen-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-linen-cream': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-leather-black': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },
  'book-13x10-hardcover-leather-tan': {
    source: 'blank',
    editor: 'new',
    preview: 'book-complex',
    withPolotnoEmbellish: true,
    withPolotnoAncestry: false,
    backgroundsCategory: ['Backgrounds', 'MyCanvas', '13.5x10.5'],
    withPolotnoBackgrounds: true,
  },

  /**
   * COUPON EDITOR
   */
  'giftcard-10': {
    editor: 'coupon',
  },
  'giftcard-15': {
    editor: 'coupon',
  },
  'giftcard-20': {
    editor: 'coupon',
  },
  'giftcard-25': {
    editor: 'coupon',
  },
  'giftcard-50': {
    editor: 'coupon',
  },
  'giftcard-75': {
    editor: 'coupon',
  },
  'giftcard-100': {
    editor: 'coupon',
  },

  "acrylic-magnet-square-small": {
    rowClassName: "justify-content-center",
    numberOfPages: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
  },

  'acrylic-print-8x10': { withQualityCheck: true },
  'acrylic-print-11x14': { withQualityCheck: true },
  'acrylic-print-12x12': { withQualityCheck: true },
  'acrylic-print-12x18': { withQualityCheck: true },
  'acrylic-print-16x20': { withQualityCheck: true },
  'acrylic-print-16x24': { withQualityCheck: true },
  'acrylic-print-20x20': { withQualityCheck: true },
  'acrylic-print-20x30': { withQualityCheck: true },
  'acrylic-print-24x36': { withQualityCheck: true },
  'acrylic-print-30x40': { withQualityCheck: true },

  'gallery-wrapped-canvas-8x8': { withQualityCheck: true },
  'gallery-wrapped-canvas-8x10': { withQualityCheck: true },
  'gallery-wrapped-canvas-11x14': { withQualityCheck: true },
  'gallery-wrapped-canvas-12x12': { withQualityCheck: true },
  'gallery-wrapped-canvas-12x36': { withQualityCheck: true },
  'gallery-wrapped-canvas-16x16': { withQualityCheck: true },
  'gallery-wrapped-canvas-16x20': { withQualityCheck: true },
  'gallery-wrapped-canvas-16x24': { withQualityCheck: true },
  'gallery-wrapped-canvas-20x24': { withQualityCheck: true },
  'gallery-wrapped-canvas-20x30': { withQualityCheck: true },
  'gallery-wrapped-canvas-20x60': { withQualityCheck: true },
  'gallery-wrapped-canvas-24x36': { withQualityCheck: true },
  'gallery-wrapped-canvas-30x40': { withQualityCheck: true },
  'gallery-wrapped-canvas-36x36': { withQualityCheck: true },
};

export const PRODUCT_EDITOR_ALTERNATIVES = [
  [
    // 'book-11x8-hardcover-linen-gray',
    // 'book-11x8-hardcover-linen-black',
    // 'book-11x8-hardcover-linen-cream',
    'book-11x8-hardcover-leather-black',
    'book-11x8-hardcover-leather-tan',
  ],
  [
    // 'book-13x10-hardcover-linen-gray',
    // 'book-13x10-hardcover-linen-black',
    // 'book-13x10-hardcover-linen-cream',
    'book-13x10-hardcover-leather-black',
    'book-13x10-hardcover-leather-tan',
  ],
];

export default PRODUCT_EDITOR_CONFIG;
